import React from 'react'
import siteConfig from '../../../common/utils/siteConfig'
import SearchResultBody from './result/searchResultBody'
import SearchNoResults from './result/searchNoResults'
import Pagination from '../../components/pagination/pagination'

const SimilarImagesPage = ({results, location, baseUrl, currentSite}) => {
  const totalHits = results.total_hits
  const matches = results.matches
  const haveResults = matches && matches.length
  const shouldShowPagination = totalHits > 0
  const pageSize = siteConfig(currentSite, 'common.search_page_size')
  const maxPagesCount = siteConfig(currentSite, 'common.max_pages_count')

  return (
    <div className='grid-container'>
      <div className='content-l -size-scale-tablet content-centre'>
        { haveResults
          ? <SearchResultBody location={location} matches={matches} view='grid' />
          : <SearchNoResults location={location} />}
        {shouldShowPagination &&
          <Pagination
            currentPage={Number(location.query.page) || 1}
            totalItemsCount={totalHits}
            pageSize={pageSize}
            location={location}
            baseUrl={baseUrl}
            maxPagesCount={maxPagesCount}
          />
        }
      </div>
    </div>
  )
}

export default SimilarImagesPage



// WEBPACK FOOTER //
// ./client/pages/search/similarImagesPage.js